import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const AnnouncementBar = ({ onVisibilityChange = null, onCtaClick = null }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [scrollY, setScrollY] = useState(0);
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [fontSize, setFontSize] = useState("14px");

  useEffect(() => {
    let ticking = false;
    let lastScrollY = 0;
    let timeoutId = null;

    const updateVisibility = () => {
      const currentScrollY = window.scrollY;
      const isScrollingDown = currentScrollY > lastScrollY;

      // Always show when at top
      if (currentScrollY < 50) {
        setIsVisible(true);
        if (onVisibilityChange) onVisibilityChange(true);
      }
      // Only hide when scrolling down
      else if (isScrollingDown) {
        // Clear any pending timeout
        if (timeoutId) clearTimeout(timeoutId);
        // Set a small delay before hiding to ensure smoothness
        timeoutId = setTimeout(() => {
          setIsVisible(false);
          if (onVisibilityChange) onVisibilityChange(false);
        }, 5);
      }
      // Show when scrolling up
      else {
        setIsVisible(true);
        if (onVisibilityChange) onVisibilityChange(true);
      }
      lastScrollY = currentScrollY;
      ticking = false;
    };

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateVisibility);
        ticking = true;
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  useEffect(() => {
    const adjustFontSize = () => {
      if (!containerRef.current || !contentRef.current) return;

      const container = containerRef.current;
      const content = contentRef.current;
      let currentFontSize = 14; // Start with default font size

      // Reset to max size first
      content.style.fontSize = "14px";
      
      // If content is wider than container, reduce font size
      while (content.scrollWidth > container.offsetWidth && currentFontSize > 10) {
        currentFontSize -= 0.5;
        content.style.fontSize = `${currentFontSize}px`;
      }

      setFontSize(`${currentFontSize}px`);
    };

    // Initial adjustment
    adjustFontSize();
    
    // Adjust on window resize
    window.addEventListener("resize", adjustFontSize);
    return () => window.removeEventListener("resize", adjustFontSize);
  }, []);

  return (
    <div  className={`announcement-bar ${!isVisible ? "hidden" : ""}`}>
      <div  className="announcement-content" ref={containerRef}>
        <div 
          ref={contentRef}
          style={{ 
            display: "inline-flex", 
            alignItems: "center",
            gap: "8px",
            whiteSpace: "nowrap",
            fontSize: fontSize
          }}
        >
          <span>Pilotpartner gesucht - sichere dir einen von drei Plätzen!</span>
          <button 
            style={{ 
              background: 'none',
              border: 'none',
              color: 'white',
              textDecoration: 'underline',
              padding: 0,
              font: 'inherit',
              cursor: 'pointer',
              marginLeft: '0px'
            }}
            onClick={onCtaClick}
          >
            Jetzt entdecken
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;
